import { render, staticRenderFns } from "./EmailAddresses.vue?vue&type=template&id=ca5daf6e&scoped=true"
import script from "./EmailAddresses.vue?vue&type=script&lang=js"
export * from "./EmailAddresses.vue?vue&type=script&lang=js"
import style0 from "./EmailAddresses.vue?vue&type=style&index=0&id=ca5daf6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5daf6e",
  null
  
)

export default component.exports